import React, { useRef, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { School, Public, Lightbulb } from '@mui/icons-material';

const bannerImages = [
  require('../images/baner/banerImg1.jpg'),
  require('../images/baner/banerImg2.jpg'),
  require('../images/baner/banerImg3.jpg'),
  require('../images/baner/banerImg4.jpg'),
];

const BannerCarousel = ({ images, interval = 3000 }) => {
  const [current, setCurrent] = useState(0);
  const timeoutRef = useRef(null);

  useEffect(() => {
    timeoutRef.current = setTimeout(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, interval);
    return () => clearTimeout(timeoutRef.current);
  }, [current, images.length, interval]);

  return (
    <div className="absolute inset-0 w-full h-full overflow-hidden z-0 flex items-center justify-center">
      <img
        key={current}
        src={images[current]}
        alt="Banner"
        className="object-cover h-full w-[100vw] min-w-[100vw] max-w-none opacity-100 absolute inset-0"
        draggable="false"
      />
    </div>
  );
};

const Hero = () => {

  return (
    <section id="hero" className="relative min-h-screen flex items-center pt-20 overflow-hidden">
      {/* Banner Image Carousel Background */}
      <BannerCarousel images={bannerImages} interval={3000} />
      {/* Overlay for darkening effect */}
      <div className="absolute inset-0 bg-black/20 z-10"></div>
      <div className="container max-w-7xl mx-auto px-4 relative z-20">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-center w-full">
          <div className="text-white">
            <h1 className="text-5xl md:text-6xl font-bold leading-tight mb-6 animate-fadeInUp">
              Empowering Students for a
              <span className="block text-yellow-400"> Brighter Tomorrow</span>
            </h1>
            <p className="text-lg md:text-xl leading-relaxed mb-8 opacity-90 animate-fadeInUp delay-200">
              At Moxie Master Public School, we nurture academic excellence, 
              character development, and global citizenship in a supportive and 
              innovative learning environment.
            </p>
            <div className="flex gap-8 mb-10 animate-fadeInUp delay-400">
              <div className="flex flex-col items-center">
                <span className="text-3xl font-bold text-yellow-400">500+</span>
                <span className="text-sm opacity-80 text-center">Students</span>
              </div>
              <div className="flex flex-col items-center">
                <span className="text-3xl font-bold text-yellow-400">50+</span>
                <span className="text-sm opacity-80 text-center">Expert Teachers</span>
              </div>
              <div className="flex flex-col items-center">
                <span className="text-3xl font-bold text-yellow-400">15+</span>
                <span className="text-sm opacity-80 text-center">Years Experience</span>
              </div>
            </div>
            <div className="flex gap-4 animate-fadeInUp delay-600">
              <Link
                to="/admissions"
                className="inline-block px-8 py-3 rounded-lg font-medium text-white bg-gray-800 hover:bg-gray-900 transition-all text-lg shadow-lg"
              >
                Enroll Now
              </Link>
              <Link 
                to="/"
                className="inline-block px-8 py-3 rounded-lg font-medium text-gray-800 border-2 border-gray-800 bg-white hover:bg-gray-800 hover:text-white transition-all text-lg shadow-lg"
              >
                Learn More
              </Link>
            </div>
          </div>
          <div className="flex justify-center items-center animate-fadeInRight delay-800">
            <div className="bg-white/95 backdrop-blur rounded-2xl p-8 shadow-2xl max-w-md w-full">
              <div className="text-center mb-8">
                <h3 className="text-gray-800 text-2xl font-semibold m-0">Why Choose Us?</h3>
              </div>
              <div className="flex flex-col gap-6">
                <div className="flex items-start gap-4">
                  <div className="text-2xl"><School style={{ fontSize: '2rem', color: '#6B7280' }} /></div>
                  <div>
                    <h4 className="text-gray-800 font-semibold mb-1 text-lg">Academic Excellence</h4>
                    <p className="text-gray-600 text-sm leading-snug m-0">Comprehensive curriculum with proven results</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="text-2xl"><Public style={{ fontSize: '2rem', color: '#6B7280' }} /></div>
                  <div>
                    <h4 className="text-gray-800 font-semibold mb-1 text-lg">Global Perspective</h4>
                    <p className="text-gray-600 text-sm leading-snug m-0">International programs and cultural exchange</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="text-2xl"><Lightbulb style={{ fontSize: '2rem', color: '#6B7280' }} /></div>
                  <div>
                    <h4 className="text-gray-800 font-semibold mb-1 text-lg">Innovation</h4>
                    <p className="text-gray-600 text-sm leading-snug m-0">Modern facilities and cutting-edge technology</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero; 